import { SVGProps } from "react";

type Logo3ETProps = SVGProps<SVGSVGElement> & {
  className?: string;
};

const Logo3ET: React.FC<Logo3ETProps> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="155"
    height="106"
    viewBox="0 0 155 106"
    fill="none"
  >
    <g filter="url(#filter0_d_1124_19881)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.0135 26.7414L54.7983 16.6931L52.5948 21.3766L42.8099 31.425L45.0135 26.7414Z"
        fill="#135F66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.7985 16.6923L22.3703 15.9141L20.1667 20.5976L52.5949 21.3759L54.7985 16.6923Z"
        fill="#135F66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.3703 15.9141L22.7436 26.2112L20.54 30.8947L20.1667 20.5976L22.3703 15.9141Z"
        fill="#135F66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.7436 26.2109L31.4415 26.4197L29.2379 31.1032L20.54 30.8945L22.7436 26.2109Z"
        fill="#135F66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.4416 26.4219L45.0138 26.7426L42.8102 31.4262L29.238 31.1054L31.4416 26.4219Z"
        fill="#135F66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M121.378 41.791L122.064 60.7336L119.861 65.4172L119.174 46.4746L121.378 41.791Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M122.064 60.7363C122.168 63.6067 123.621 65.0715 126.422 65.1387L124.218 69.8223C121.417 69.7551 119.965 68.2902 119.861 65.4199L122.064 60.7363Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M126.422 65.1356C128.679 65.1974 130.878 64.6809 132.795 63.6384L130.591 68.3219C128.674 69.3645 126.476 69.881 124.218 69.8191L126.422 65.1356Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M132.795 63.6406L133.16 73.7001L130.956 78.3837L130.591 68.3242L132.795 63.6406Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M133.159 73.6988C131.757 74.459 130.253 75.0452 128.681 75.444L126.477 80.1275C128.049 79.7287 129.553 79.1425 130.956 78.3824L133.159 73.6988Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M128.681 75.4445C127.038 75.8701 125.134 76.0594 122.962 76.0073L120.758 80.6908C122.93 80.7429 124.835 80.5536 126.477 80.1281L128.681 75.4445Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M122.962 76.0085C120.959 75.9604 119.139 75.7117 117.493 75.2598L115.29 79.9433C116.936 80.3952 118.755 80.6439 120.759 80.692L122.962 76.0085Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.493 75.2581C115.913 74.8416 114.441 74.0561 113.213 72.9727L111.009 77.6562C112.238 78.7397 113.709 79.5252 115.29 79.9417L117.493 75.2581Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M113.213 72.9732C112.002 71.9018 111.039 70.5184 110.321 68.8262L108.117 73.5097C108.835 75.202 109.798 76.5853 111.009 77.6568L113.213 72.9732Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M110.321 68.8275C109.602 67.1376 109.196 65.0002 109.103 62.418L106.899 67.1015C106.993 69.6838 107.399 71.8212 108.117 73.5111L110.321 68.8275Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M109.103 62.4175L108.914 57.2227L106.711 61.9062L106.899 67.101L109.103 62.4175Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.914 57.2219L78.0185 56.4805L75.8149 61.164L106.711 61.9055L108.914 57.2219Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.0185 56.4805C78.7485 59.353 80.129 61.5438 82.1543 63.0449L79.9507 67.7285C77.9254 66.2273 76.5449 64.0366 75.8149 61.164L78.0185 56.4805Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.1547 63.0449C84.1801 64.5486 86.6501 65.3381 89.5652 65.4081L87.3616 70.0916C84.4465 70.0217 81.9765 69.2322 79.9511 67.7285L82.1547 63.0449Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.5648 65.407C91.7365 65.4591 93.6677 65.1454 95.3553 64.4707L93.1518 69.1543C91.4641 69.8289 89.5329 70.1427 87.3612 70.0906L89.5648 65.407Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.3552 64.4708C97.0458 63.8014 98.7744 62.6879 100.547 61.1377L98.3433 65.8213C96.5708 67.3715 94.8422 68.4849 93.1516 69.1543L95.3552 64.4708Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M100.547 61.1387L108.238 67.6662L106.034 72.3497L98.3437 65.8222L100.547 61.1387Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.238 67.6638C106.193 70.1683 103.574 72.1724 100.567 73.5325L98.3635 78.216C101.371 76.8559 103.99 74.8519 106.034 72.3473L108.238 67.6638Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M100.567 73.5357C97.5345 74.918 93.9315 75.5592 89.756 75.459L87.5525 80.1425C91.7279 80.2428 95.3309 79.6016 98.3637 78.2193L100.567 73.5357Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.7559 75.4585C86.3284 75.3763 83.1218 74.7518 80.1361 73.5801L77.9326 78.2636C80.9182 79.4354 84.1248 80.0598 87.5523 80.1421L89.7559 75.4585Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.1358 73.5798C77.2472 72.4699 74.5918 70.8075 72.3366 68.6973L70.133 73.3808C72.3882 75.4911 75.0436 77.1534 77.9323 78.2634L80.1358 73.5798Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.3369 68.6977C70.5771 67.0407 69.0891 65.136 67.9296 63.0566L65.726 67.7402C66.8855 69.8195 68.3735 71.7243 70.1333 73.3813L72.3369 68.6977Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M67.9297 63.0565C67.8187 63.3316 67.7009 63.6032 67.5766 63.8713L65.373 68.5548C65.4973 68.2868 65.6151 68.0151 65.7261 67.74L67.9297 63.0565Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M67.576 63.8723C66.1462 66.9549 63.8495 69.5592 60.9249 71.4002L58.7213 76.0838C61.6459 74.2428 63.9426 71.6385 65.3724 68.5559L67.576 63.8723Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.9256 71.3979C57.7467 73.3991 53.9684 74.4087 50.067 74.2997L47.8635 78.9833C51.7648 79.0923 55.5431 78.0826 58.722 76.0815L60.9256 71.3979Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.0669 74.3L24.465 73.6855L22.2614 78.3691L47.8633 78.9835L50.0669 74.3Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.4648 73.6857L24.0915 63.3887L21.8879 68.0722L22.2612 78.3692L24.4648 73.6857Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0915 63.3887L49.6908 64.003L47.4872 68.6866L21.8879 68.0722L24.0915 63.3887Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.6907 64.0023C53.0285 64.0824 55.8647 62.352 57.2085 59.7222L55.0049 64.4057C53.6611 67.0356 50.8249 68.766 47.4871 68.6859L49.6907 64.0023Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M57.2091 59.7213C57.7851 58.5942 58.0869 57.302 58.0367 55.9162L55.8331 60.5998C55.8833 61.9855 55.5815 63.2778 55.0055 64.4049L57.2091 59.7213Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.0364 55.9167C57.8689 51.2947 53.8553 47.5306 49.082 47.416L46.8784 52.0996C51.6517 52.2141 55.6653 55.9783 55.8328 60.6002L58.0364 55.9167Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.0819 47.4167L31.9631 47.0059L29.7595 51.6894L46.8783 52.1003L49.0819 47.4167Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.963 47.0049L60.4288 16.8262L58.2252 21.5097L29.7594 51.6885L31.963 47.0049Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.4289 16.8262L65.8031 16.9552L63.5995 21.6387L58.2253 21.5097L60.4289 16.8262Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.8031 16.957L66.1454 26.3984L63.9419 31.0819L63.5996 21.6406L65.8031 16.957Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.1452 26.3986L55.8838 37.8581L53.6802 42.5416L63.9416 31.0821L66.1452 26.3986Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.8842 37.8574C59.7883 39.3606 63.1736 41.9919 65.556 45.375L63.3524 50.0586C60.9701 46.6754 57.5847 44.0441 53.6806 42.541L55.8842 37.8574Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.5557 45.3738C65.7515 44.5734 65.9818 43.789 66.2642 43.0181L64.0606 47.7017C63.7782 48.4726 63.5479 49.257 63.3521 50.0573L65.5557 45.3738Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.2641 43.0183C66.4748 42.4272 66.7116 41.8475 66.9735 41.2806L64.7699 45.9642C64.508 46.5311 64.2712 47.1108 64.0605 47.7018L66.2641 43.0183Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.9737 41.2829C67.9025 39.273 69.1478 37.4236 70.6709 35.7984L68.4673 40.4819C66.9442 42.1072 65.6989 43.9565 64.7701 45.9665L66.9737 41.2829Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.6707 35.7974C72.6116 33.7455 74.9874 32.1211 77.6541 31.0221L75.4505 35.7057C72.7838 36.8046 70.408 38.4291 68.4671 40.4809L70.6707 35.7974Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77.6542 31.0217C80.3802 29.8796 83.4313 29.3502 86.8041 29.4312L84.6006 34.1147C81.2277 34.0338 78.1766 34.5631 75.4506 35.7053L77.6542 31.0217Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M86.8044 29.4316C90.6331 29.5235 93.9729 30.2612 96.8218 31.6472L94.6182 36.3307C91.7693 34.9448 88.4295 34.2071 84.6008 34.1152L86.8044 29.4316Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M96.8219 31.6465C99.5759 32.9601 102.029 34.8329 104.004 37.1292L101.801 41.8128C99.8256 39.5165 97.3723 37.6437 94.6183 36.33L96.8219 31.6465Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.004 37.1289C105.967 39.4427 107.46 42.0819 108.398 44.8949L106.194 49.5784C105.257 46.7655 103.763 44.1262 101.8 41.8125L104.004 37.1289Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.398 44.8965L108.477 45.146L106.273 49.8295L106.194 49.58L108.398 44.8965Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.477 45.145L107.491 17.957L105.287 22.6406L106.273 49.8286L108.477 45.145Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M107.491 17.957L120.525 18.2698L118.321 22.9534L105.287 22.6406L107.491 17.957Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M120.525 18.2695L120.989 31.0715L118.785 35.7551L118.321 22.9531L120.525 18.2695Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M120.989 31.0703L134.054 31.3839L131.85 36.0674L118.785 35.7539L120.989 31.0703Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.054 31.3865L124.448 41.8666L122.244 46.5502L131.85 36.07L134.054 31.3865Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M124.448 41.8647L121.378 41.791L119.174 46.4746L122.244 46.5483L124.448 41.8647Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77.5612 48.6453C77.7766 47.1657 78.1544 45.8462 78.6961 44.6861L76.4925 49.3697C75.9508 50.5297 75.573 51.8492 75.3576 53.3288L77.5612 48.6453Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.6959 44.6854C79.1959 43.6146 79.8356 42.6796 80.6162 41.8799L78.4126 46.5635C77.632 47.3632 76.9923 48.2982 76.4923 49.369L78.6959 44.6854Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.6166 41.8808C82.24 40.2196 84.425 39.422 87.169 39.4879L84.9654 44.1714C82.2214 44.1056 80.0364 44.9032 78.4131 46.5643L80.6166 41.8808Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.1689 39.4883C89.9131 39.5541 92.1446 40.4703 93.8642 42.2416L91.6606 46.9252C89.941 45.1538 87.7095 44.2377 84.9653 44.1718L87.1689 39.4883Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.8642 42.2402C95.5836 44.0092 96.6963 46.3035 97.1991 49.1157L94.9955 53.7993C94.4927 50.987 93.3801 48.6927 91.6606 46.9238L93.8642 42.2402Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.1992 49.1158L77.5614 48.6445L75.3579 53.3281L94.9956 53.7994L97.1992 49.1158Z"
        fill="#76959B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M122.064 60.7343L121.377 41.7917L124.448 41.8654L134.054 31.3852L120.989 31.0717L120.525 18.2697L107.491 17.9569L108.476 45.1449L108.398 44.8954C107.46 42.0825 105.967 39.4433 104.004 37.1295C102.029 34.8332 99.5755 32.9604 96.8216 31.6468C93.9727 30.2608 90.6329 29.5231 86.8042 29.4312C83.4313 29.3503 80.3803 29.8796 77.6542 31.0217C74.9875 32.1207 72.6117 33.7452 70.6709 35.797C68.7182 37.8806 67.2221 40.3326 66.2642 43.0192C65.9817 43.7901 65.7515 44.5745 65.5557 45.3749C63.1733 41.9917 59.788 39.3604 55.8839 37.8573L66.1453 26.3978L65.803 16.9564L60.4288 16.8274L31.963 47.0062L49.0818 47.417C53.8551 47.5316 57.8687 51.2957 58.0363 55.9177C58.2037 60.5368 54.4592 64.1173 49.6909 64.0029L24.0916 63.3885L24.4649 73.6856L50.0668 74.3C53.9681 74.409 57.7464 73.3993 60.9253 71.3982C64.1042 69.3971 66.5413 66.4942 67.9296 63.0555C69.089 65.1349 70.5771 67.0396 72.3369 68.6966C74.5921 70.8068 77.2475 72.4692 80.1362 73.5791C83.1219 74.7509 86.3284 75.3753 89.7559 75.4576C93.9314 75.5578 97.5343 74.9166 100.567 73.5343C103.574 72.1742 106.193 70.1701 108.238 67.6656L100.547 61.1381C98.7746 62.6883 97.046 63.8017 95.3554 64.4711C93.6678 65.1457 91.7366 65.4595 89.5649 65.4074C86.6498 65.3374 84.1798 64.5479 82.1544 63.0442C80.1292 61.5431 78.7487 59.3523 78.0186 56.4798L108.914 57.2213L109.103 62.4161C109.196 64.9984 109.602 67.1357 110.321 68.8257C111.039 70.5179 112.002 71.9012 113.213 72.9727C114.441 74.0562 115.913 74.8417 117.493 75.2582C119.139 75.7101 120.958 75.9588 122.962 76.0069C125.134 76.059 127.038 75.8697 128.681 75.4442C130.253 75.0454 131.757 74.4591 133.159 73.699L132.795 63.6395C130.878 64.6821 128.679 65.1986 126.422 65.1367C123.621 65.0695 122.168 63.6047 122.064 60.7343ZM80.6164 41.881C78.9903 43.5471 77.9755 45.8003 77.5612 48.6457L97.199 49.117C96.6962 46.3047 95.5836 44.0104 93.8641 42.2415C92.1445 40.4701 89.913 39.554 87.1688 39.4881C84.4248 39.4223 82.2398 40.2199 80.6164 41.881Z"
        fill="white"
      />
      <path
        d="M45.0138 26.7407L54.7986 16.6923L22.3704 15.9141L22.7437 26.2112L31.4416 26.4199L45.0138 26.7407Z"
        fill="#4DA1A9"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1124_19881"
        x="0.166748"
        y="0.914062"
        width="153.887"
        height="104.785"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1124_19881"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1124_19881"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Logo3ET;
